if (!customElements.get('product-page')) {
  class ProductPage extends Product {
    constructor() {
      super();

      this.productDetail = this.productDetail || document.querySelector('.js-product-details');
      this.photosExpander = this.querySelector('.js-photos-extender');
      if (this.photosExpander) {
        this.expandablePhotos = this.querySelectorAll('.pdp__photos-item.hidden-desktop');
        this.photosExpander.addEventListener('click', ()=>{
          if(this.photosExpander.dataset.isOpen == 'false'){
            this.expandablePhotos.forEach((photo)=>{
              photo.classList.remove('hidden-desktop');
            })
            this.photosExpander.dataset.isOpen = 'true';
            this.photosExpander.querySelector('.show-more__text').textContent = 'Vise Færre Bilder';
            this.photosExpander.querySelector('.show-more__icon').style.transform = 'rotate(180deg)';
          } else {
            this.expandablePhotos.forEach((photo)=>{
              photo.classList.add('hidden-desktop');
            })
            this.photosExpander.dataset.isOpen = 'false';
            this.photosExpander.querySelector('.show-more__text').textContent = 'Vise Flere Bilder';
            this.photosExpander.querySelector('.show-more__icon').style.transform = 'rotate(0deg)';
          }
        })
      }
      this.isHeihusPage = this.querySelector('.js-heihus-variants') ? true : false;
      this.bindEvents();
    }

    connectedCallback() {
      requirejs(['pubsub'], () => {
        this.syncCurrentVariant = window.subscribeEvent(
          window.PUB_SUB_EVENTS.syncCurrentVariant,
          ({ source, data }) => {
            if (source == 'product-sticky') this.catchSyncProductOnSticky(data.currentVariantId);
          }
        );
      })
    }

    bindEvents() {
      this.updateOptions();
      this.getVariantData();
      this.updateMasterId();
      this.initForm();
      this.handleQtyInput();
      this.toggleFieldset();
      this.setupCarousel();
      this.closeVariantDrawer();
      this.updateVariantStatuses();
      this.addToRecentViews();

      this.addEventListener('change', (event) => {
        event.preventDefault();
        this.handleChangedOptions(event);
      });

      this.toggleAccordions();
      this.toggleThumbnail();
      this.clickToShowProductReview();

      if(this.isHeihusPage) {
        this.updateHeihusPrices();
      }
    }

    updateHeihusPrices(){
      const groups = this.querySelectorAll('.js-main-product-fieldset');
      groups.forEach((group)=>{
        const selectedOptions = this.options.filter((option, index)=>{
          if (index != (group.dataset.index - 1)) return option;
        })
        const filterVariants = this.variantData.filter((variant) => {
          return !selectedOptions
            .map((option, index) => {
              return variant.options.includes(option);
            })
            .includes(false);
        })
        filterVariants.forEach((variant)=>{
          const currentOption = variant.options[group.dataset.index - 1];
          const priceText = group.querySelector(`.js-variant-price[data-value='${currentOption}']`);
          const differText = group.querySelector(`.js-variant-differ[data-value='${currentOption}']`);
          if (variant?.price && priceText) 
            priceText.innerHTML = window.localCurrency.formatPrice(variant?.price);
          if (variant?.compare_at_price && differText){
            if (variant?.compare_at_price > variant?.price){
              differText.parentElement.classList.remove('hidden');
              differText.innerHTML = window.localCurrency.formatPrice(variant?.compare_at_price - variant?.price);
            } else {
              differText.parentElement.classList.add('hidden');
            }
          }
        })
      })
    }
    /** PRODUCT PAGE: UPDATE PRODUCT INFORMATION */
    handleChangedOptions(event) {
      const isInputOption =
        event.target.classList.contains('js-product-option') ||
        event.target.classList.contains('js-product-option-swatch');

      if (isInputOption) {
        publishEvent(PUB_SUB_EVENTS.variantChange, {
          source: 'product-form',
          data: { currentVariant: this.currentVariant }
        });

        this.onVariantChange(event, 'page');
        this.updateURL();
        this.updateVariantStatuses();
        this.updateInventoryStock();
        this.updateSKU();
        this.updateInventoryLocation();
        this.updateInventoryHTML();
        this.updateExtraInfo();

        if(this.isHeihusPage) {
          this.updateHeihusPrices();
        }

        window.publishEvent(window.PUB_SUB_EVENTS.syncCurrentVariant, {
          source: 'product-page',
          data: { currentVariant: this.currentVariant }
        });
      }
    }

    updateExtraInfo(){
      if (this.dataset.extraItem != 'true') return;
      const extraItemContainer = this.querySelector('.pdp__extras');
      if (!extraItemContainer) return;
      if (this.currentVariant.title.toLowerCase().includes('hvit matt')){
        extraItemContainer.classList.remove('active');
      } else {
        extraItemContainer.classList.add('active');
      }
    }

    /** Override update options **/
    updateOptions() {
      this.options = [];

      for (let index = 1; index <= 3; index++) {
        const fieldsets = Array.from(
          this.querySelectorAll(`.js-main-product-fieldset[data-index='${index}']`)
        );

        const selectedOption = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)
            ?.value;
        });

        this.options.push(...selectedOption);
      }
    }

    updateInventoryLocation() {
      const qdnInventories = this.querySelectorAll('qdn-inventory-locations');

      if (!qdnInventories || !this.currentVariant?.id) return;

      const requiredShipping = this.currentVariant.requires_shipping || false;

      qdnInventories.forEach((qdnInventory) => {
        qdnInventory?.onVariantChange(this.currentVariant.id, requiredShipping);
      });
    }

    updateURL() {
      if (this.dataset.updateUrl === 'false') return;

      !this.currentVariant
        ? history.replaceState({}, '', `${this.dataset.url}`)
        : history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateMedia() {
      const productImages = this.querySelectorAll('.js-featured-image');
      const currentVariantId = `${this.currentVariant?.id || ''}`;
      if (!productImages) return;

      const isMobile = window.matchMedia('(max-width: 960px)').matches;

      productImages.forEach((imageTag, index) => {
        const attachedVariants = imageTag.dataset.variants;

        attachedVariants.includes(currentVariantId)
          ? imageTag.classList.remove('is-hidden')
          : imageTag.classList.add('is-hidden');

        // slideTo on mobile
        if (isMobile && attachedVariants.includes(currentVariantId)) {
          this.mainSwiper?.slideTo(index);
        }
      });
    }

    updateInventoryStock() {
      let statusText = this.querySelector('.js-variant-status'),
        statusQty = this.querySelector('.js-inventory-qty'),
        status = this.getInventoryStatus(this.currentVariant);

      if (statusText) statusText.dataset.status = status;
      if (statusQty) {
        statusQty.textContent = this.currentVariant?.quantity || 0;
      }
    }

    getInventoryStatus(variant) {
      let inventoryStatus = 'out-stock';

      if (variant) {
        const { inventory_management, inventory_policy, quantity } = variant;

        if (inventory_management == 'shopify') {
          if (quantity > 0)
            quantity > 1 ? (inventoryStatus = 'in-stock') : (inventoryStatus = '1-left');
          else
            inventory_policy == 'continue'
              ? (inventoryStatus = 'continue')
              : (inventoryStatus = 'out-stock');
        } else inventoryStatus = 'unavailable';
      }

      return inventoryStatus;
    }

    updateInventoryHTML() {
      const salePoint = this.querySelector('.js-sale-point');
      if (!salePoint) return;
      if (!this.currentVariant) {
        salePoint.classList.add('hidden');

        return;
      }

      salePoint.classList.remove('hidden');

      if (!this.inventoryHTML)
        this.inventoryHTML =
          this.querySelector('.js-variants-inventory').content.firstElementChild.cloneNode(true);

      const selectedSalePoint = this.inventoryHTML.querySelector(
        `.js-sale-point[data-id="${this.currentVariant.id}"]`
      );

      if (selectedSalePoint) salePoint.innerHTML = selectedSalePoint.innerHTML;
      else salePoint.classList.add('hidden');
    }

    /** PRODUCT PAGE: VARIANT SELECTORS */
    closeVariantDrawer() {
      const variantCloses = this.querySelectorAll('.js-variant-close');
      if (!variantCloses) return;

      variantCloses.forEach((element) => {
        element.addEventListener('click', () => {
          element.closest('.js-fieldset-wrap').classList.remove('is-open');
          this.productDetail.classList.remove('is-zindex');
        });
      });
    }

    toggleFieldset() {
      const fieldsetList = this.querySelectorAll('.js-fieldset-toggle');
      const fieldsetWrap = this.querySelectorAll('.js-fieldset-wrap');

      if (!fieldsetList || !fieldsetWrap) return;

      fieldsetList.forEach((fieldset) => {
        fieldset.addEventListener('click', () => {
          this.updateVariantInfo(fieldset.nextElementSibling, fieldset.dataset.index);

          fieldset.nextElementSibling.classList.add('is-open');
          this.productDetail.classList.add('is-zindex');
        });
      });

      // Update content in fieldset tag
      fieldsetWrap.forEach((fieldset) => {
        fieldset.addEventListener('input', (event) => {
          const isOptionChecked = event.target.classList.contains('js-product-option');

          if (isOptionChecked) {
            const selectedValue = fieldset.querySelector('.js-product-option:checked').value;
            fieldset.parentElement.querySelector('.js-selected-value').textContent = selectedValue;

            fieldset.classList.remove('is-open');

            window.debounce(() => {
              this.productDetail.classList.remove('is-zindex');
            })();
          }
        });

        fieldset.addEventListener('click', (event) => {
          if (!fieldset.children.item(0).contains(event.target)) {
            fieldset.classList.remove('is-open');

            window.debounce(() => {
              this.productDetail.classList.remove('is-zindex');
            })();
          }
        });
      });
    }

    updateVariantInfo(variantDrawer, optionIndex) {
      if (!variantDrawer || !optionIndex) {
        return;
      }
      const selectedOptions = this.options.filter((option, index) => {
        if (index != optionIndex) return option;
      });

      const filterVariants = this.variantData.filter((variant) => {
        return !selectedOptions
          .map((option, index) => {
            return variant.options.includes(option);
          })
          .includes(false);
      });

      filterVariants.forEach((variant) => {
        const currentOption = variant.options[optionIndex],
          featureImage = variant?.featured_image,
          priceText = variantDrawer.querySelector(
            `.js-variant-price[data-value='${currentOption}']`
          ),
          compareText = variantDrawer.querySelector(
            `.js-variant-compare-price[data-value='${currentOption}']`
          ),
          imageTag = variantDrawer.querySelector(`.js-variant-img[data-value='${currentOption}']`);

        if (featureImage) {
          imageTag.nextElementSibling.classList.add('hidden');
          imageTag.classList.remove('hidden');
          imageTag.src = featureImage;
        } else {
          imageTag.nextElementSibling.classList.remove('hidden');
          imageTag.classList.add('hidden');
        }

        if (variant?.price) priceText.innerHTML = window.localCurrency.formatPrice(variant?.price);
        if (variant?.compare_at_price > variant?.price && variant?.compare_at_price){
          compareText.innerHTML = window.localCurrency.formatPrice(variant?.compare_at_price);
          compareText.classList.remove('hidden');
        } else {
          compareText.classList.add('hidden');
        }
      });

      // show info with unavailable variant
      let inputOptions = [...variantDrawer.querySelectorAll('.js-product-option')];

      if (inputOptions) {
        const allOptions = inputOptions.map((option) => option.value);
        const filterOptions = filterVariants.map((variant) => variant.options[optionIndex]);
        const missingOptions = allOptions.filter((option) => !filterOptions.includes(option));

        if (missingOptions.length > 0) {
          missingOptions.forEach((option) => {
            const priceText = variantDrawer.querySelector(
                `.js-variant-price[data-value='${option}']`
              ),
              imageTag = variantDrawer.querySelector(`.js-variant-img[data-value='${option}']`),
              placeholderElement = imageTag?.nextElementSibling;

            imageTag?.classList?.add('hidden');
            placeholderElement?.classList?.remove('hidden');

            priceText && (priceText.textContent = window.variantStrings.unavailable);
          });
        }
      }
    }

    /** PRODUCT PAGE: CATCH SYNC PRODUCT FROM PRODUCT-STICKY */
    catchSyncProductOnSticky(variantId) {
      if (!this.variantData) return;

      const currentVariant = this.variantData.find((variant) => variant.id == variantId);

      if (!currentVariant) return;

      currentVariant.options.forEach((option) => {
        const optionInput = this.querySelector(`.js-product-option[value='${option}']`);

        if (optionInput) optionInput.parentElement.click();
      });
    }

    /** PRODUCT PAGE: THUMBNAILS */
    toggleThumbnail() {
      const zoomButtons = this.querySelectorAll('.js-media-zoom'),
        thumbnailGallery = this.querySelector('.js-thumbs-gallery');

      if (!zoomButtons || zoomButtons.length == 0 || !thumbnailGallery) return;

      zoomButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (thumbnailGallery.dataset.loaded === 'false') {
            thumbnailGallery.dataset.loaded = 'true';
            this.loadedThumbGallery();
          }

          thumbnailGallery.classList.add('is-open');

          setTimeout(() => {
            let idx = button.querySelector(".pdp__photos-media").getAttribute('data-image-order')
            const swiperCarousel =(document.querySelector('.js-thumbnail-main .swiper-carousel'));
            swiperCarousel.scrollTo(parseInt(idx)-1)
          }, 100)
        });
      });
    }

    closeThumbnails() {
      const thumbnailCloses = this.querySelectorAll('.js-thumbs-close'),
        thumbnailGallery = this.querySelector('.js-thumbs-gallery');

      if (!thumbnailGallery || !thumbnailCloses) return;

      thumbnailCloses.forEach((thumbnailClose) => {
        thumbnailClose.addEventListener('click', () => {
          thumbnailGallery.classList.remove('is-open');
          this.enableScrollLock?.();
        });
      });
    }

    loadedThumbGallery() {
      const mainCarousel = this.querySelector('.js-thumbnail-main'),
        templateCarousel = this.querySelector('.js-thumbnails-template');

      if (!mainCarousel || !templateCarousel) return;

      const templateContent = templateCarousel.content.firstElementChild.cloneNode(true).outerHTML;

      mainCarousel.innerHTML = templateContent;

      if (window.updateLazyLoad) window.updateLazyLoad();

      this.closeThumbnails();
    }

    /** PRODUCT PAGE: SETUP CAROUSELS */
    setupCarousel() {
      const mainSwiper = this.querySelector('.js-product-carousel-photos');
      const carouselID = mainSwiper?.dataset?.selector;

      if (!mainSwiper || !carouselID) {
        return;
      }

      const onCarousel = () => {
        const breakpoint = window.matchMedia('(min-width: 960px)');

        if (breakpoint.matches === true) {
          if (this.thumbnailSwiper !== undefined) this.thumbnailSwiper?.destroy(true, true);
          if (this.mainSwiper !== undefined) this.mainSwiper?.destroy(true, true);

          return;
        } else if (breakpoint.matches === false && (!this.thumbnailSwiper || !this.mainSwiper)) {

          requirejs(['swiper'], (Swiper) => {

            this.thumbnailSwiper = new Swiper(`.js-carousel-thumbnail-${carouselID}`, {
              lazy: true,
              resistanceRatio: 0.4,
              speed: 300,
              loop: false,
              slidesPerView: 5.8,
              spaceBetween: 4
            });
  
            this.mainSwiper = new Swiper(`.js-carousel-${carouselID}`, {
              lazy: true,
              resistanceRatio: 0.4,
              speed: 300,
              loop: false,
              slidesPerView: 1,
              spaceBetween: 16,
              effect: 'fade',
              fadeEffect: {
                crossFade: true
              },
              breakpoints: {
                960: {
                  slidesPerView: null
                }
              },
              pagination: {
                el: `.js-swiper-pagination-${carouselID}`,
                clickable: true,
                type: 'progressbar'
              },
              navigation: {
                nextEl: `.js-swiper-next-${carouselID}`,
                prevEl: `.js-swiper-prev-${carouselID}`
              },
              thumbs: {
                swiper: this.thumbnailSwiper,
                multipleActiveThumbs: false
              }
            });
          });
        }
      };

      onCarousel();

      window.addEventListener(
        'resize',
        window.debounce(() => onCarousel(), 300)
      );
    }

    /** PRODUCT PAGE: ELEMENTS */
    toggleAccordions() {
      const accordions = this.querySelectorAll('.js-accordion-toggle');
      if (!accordions) return;

      accordions.forEach((accordion) => {
        accordion.addEventListener('click', () => {
          const parentElement = accordion.parentElement,
            content = accordion.nextElementSibling,
            isOpen = accordion.parentElement.classList.contains('is-open');

          if (isOpen) {
            parentElement.classList.remove('is-open');
            content.classList.add('hidden');
            content.style.maxHeight = null;
          } else {
            parentElement.classList.add('is-open');
            content.classList.remove('hidden');

            requestAnimationFrame(() => {
              content.style.maxHeight = 'max-content';
            });

            /* Trigger first nested accordion */
            const firstNestedAccordion = content.querySelector('.js-accordion-toggle');

            if (firstNestedAccordion) {
              firstNestedAccordion.parentElement.classList.add('is-open');
              firstNestedAccordion.nextElementSibling.classList.remove('hidden');

              requestAnimationFrame(() => {
                firstNestedAccordion.nextElementSibling.style.maxHeight =
                  'max-content';
              });
            }
          }
        });
      });
    }

    /** PRODUCT PAGE: ADD RECENT VIEWS AUTOMATICALLY */
    addToRecentViews() {
      const productHandle = this.dataset.handle;
      if (!productHandle) return;

      const currentRecentViews = localStorage.getItem('recentViews');
      let recentViewsHandles = '';

      if (currentRecentViews) {
        const isExist = currentRecentViews.includes(productHandle);
        if (!isExist) recentViewsHandles = currentRecentViews + '||' + productHandle;
      } else recentViewsHandles = productHandle;

      // Only get 10 newest products
      const recentViewsHandleArr = recentViewsHandles.split('||');
      if (recentViewsHandleArr && recentViewsHandleArr.length > 10) {
        const newestRecentProducts = recentViewsHandleArr.slice(-10);
        recentViewsHandles = newestRecentProducts.join('||');
      }

      if (recentViewsHandles) localStorage.setItem('recentViews', recentViewsHandles);
    }

    /** PRODUCT REVIEW LINK: OVERRIDE APP DEFAULT */
    clickToShowProductReview() {
      const productReviewStar = this.querySelector('.js-product-review-link');
      if (!productReviewStar) return;
      const productReviews = document.getElementById(productReviewStar.dataset.target);
      if (!productReviews) return;

      productReviewStar.addEventListener('click', () => {
        productReviews.classList.add('is-open');
        productReviews.lastElementChild.style.maxHeight = 'max-content';
        productReviews.lastElementChild.classList.remove('hidden');
        productReviews.scrollIntoView();
      });
    }
  }

  customElements.define('product-page', ProductPage);
}
